import { Routes, Route, Navigate } from 'react-router-dom';
import CallingDashboard from './pages/CallingDashboard';
import CallDevicesAdmin from './pages/CallDevicesAdmin';
import CallTargetsAdmin from './pages/CallTargetsAdmin';
import PermissionRoute from '../../routes/PermissionRoute';

const CallSyncRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={(
        <PermissionRoute requiredPermissions={[{ module: 'callAnalytics', action: 'view' }]}>
          <CallingDashboard />
        </PermissionRoute>
      )}
    />
    <Route
      path="dashboard"
      element={(
        <PermissionRoute requiredPermissions={[{ module: 'callAnalytics', action: 'view' }]}>
          <CallingDashboard />
        </PermissionRoute>
      )}
    />
    <Route
      path="devices"
      element={(
        <PermissionRoute requiredPermissions={[{ module: 'callDevices', action: 'view' }]}>
          <CallDevicesAdmin />
        </PermissionRoute>
      )}
    />
    <Route
      path="targets"
      element={(
        <PermissionRoute requiredPermissions={[{ module: 'callTargets', action: 'view' }]}>
          <CallTargetsAdmin />
        </PermissionRoute>
      )}
    />
    <Route path="*" element={<Navigate to="/calling" replace />} />
  </Routes>
);

export default CallSyncRoutes;
